import type { RequiredGeneric } from '@pba/react-utils';
import { Form, FormSection, Icon, Input } from 'ui';
import type { ExtendedDetailFormContentValues } from '../DetailFormContent';

export type ExtendedReminderDetailFormContentValues = {
  name: string;
};

const ReminderDetailFormContent = <T extends ExtendedReminderDetailFormContentValues = never>(
  _: RequiredGeneric<T>,
) => (
  <FormSection title={{ children: 'Reminder details', icon: <Icon icon="bell-ringing-line" /> }}>
    <Form.Item<ExtendedDetailFormContentValues>
      label="Reminder name"
      name="name"
      rules={[{ required: true, whitespace: true }]}
    >
      <Input />
    </Form.Item>
  </FormSection>
);

export default ReminderDetailFormContent;
